const Pagani = [
    {
        ID: "pagani_1",
        name: "Huayra",
        brand: "Pagani",
        price: 77.1,
        engine: "V12 6,0L",
        max: 370,
        version: "7 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/s9BHvL6/huayra.webp",
        link: "/brands/pagani/huayra",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_2",
        name: "Zonda Riviera",
        brand: "Pagani",
        price: 129,
        engine: "V12 7,2L",
        max: 350,
        version: "7 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/tLNM4TQ/Zonda-Riviera.webp",
        link: "/brands/pagani/zonda-riviera",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_3",
        name: "Zonda R",
        brand: "Pagani",
        price: 53,
        engine: "V12 6,0L",
        max: 370,
        version: "6 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/f1Y1nZV/Zonda-R.webp",
        link: "/brands/pagani/zonda-r",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    // {
    //     ID: "pagani_4",
    //     name: "Zonda R Evolution",
    //     brand: "Pagani",
    //     price: "53 Tỷ",
    //     engine: "V12 6,0L",
    //     max: 370,
    //     version: "6 AT",
    //     type: "Coupe",
    //     avatar: "https://i.ibb.co/f1Y1nZV/Zonda-R.webp",
    // },
    {
        ID: "pagani_5",
        name: "Zonda Cinque Roadster",
        brand: "Pagani",
        price: 42,
        engine: "V12 7,3L",
        max: 350,
        version: "CIMA",
        type: "Coupe",
        avatar: "https://i.ibb.co/LkYN3vc/cinque.webp",
        link: "/brands/pagani/zonda-cinque-roadster",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_6",
        name: "Zonda Tricolore",
        brand: "Pagani",
        price: 157,
        engine: "V12 7,3L",
        max: 350,
        version: "6 SG",
        type: "Coupe",
        avatar: "https://i.ibb.co/S7VQK2H/Zonda-Tricolore.webp",
        link: "/brands/pagani/zonda-tricolore",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },

    {
        ID: "pagani_7",
        name: "Zonda HP Barchetta",
        brand: "Pagani",
        price: 412,
        engine: "V12 7,3L",
        max: 355,
        version: "6",
        type: "Coupe",
        avatar: "https://i.ibb.co/dWhLgX4/beta.webp",
        link: "/brands/pagani/zonda-hp-barchetta",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_8",
        name: "Zonda Revolucion",
        brand: "Pagani",
        price: 65,
        engine: "V12 6,0L",
        max: 349,
        version: "6",
        type: "Coupe",
        avatar: "https://i.ibb.co/LNqND7m/Revolucion.webp",
        link: "/brands/pagani/zonda-revolucion",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_9",
        name: "Huayra R",
        brand: "Pagani",
        price: 72.6,
        engine: "V12 6,0L",
        max: 383,
        version: "7 S",
        type: "Coupe",
        avatar: "https://i.ibb.co/2WjzH61/1-AYHB-removebg-preview.webp",
        link: "/brands/pagani/huayra-r",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_10",
        name: "Huayra Roadster BC",
        brand: "Pagani",
        price: 81,
        engine: "V12 6,0L",
        max: 340,
        version: "7 XTRAC",
        type: "Coupe",
        avatar: "https://i.ibb.co/dQkLbh5/BCRoad.webp",
        link: "/brands/pagani/huayra-roadster-bc",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_11",
        name: "Huayra Roadster Gyrfalcon",
        brand: "Pagani",
        price: 61,
        engine: "V12 6,0L",
        max: 383,
        version: "7",
        type: "Coupe",
        avatar: "https://i.ibb.co/23nTHDn/falcon.webp",
        link: "/brands/pagani/huayra-roadster-gyrfalcon",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_12",
        name: "Huayra Pearl",
        brand: "Pagani",
        price: 18.7,
        engine: "V12 6,0L",
        max: 380,
        version: "7 XTRAC",
        type: "Coupe",
        avatar: "https://i.ibb.co/1QJTXN6/Pearl.webp",
        link: "/brands/pagani/huayra-pearl",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_13",
        name: "Huayra Imola",
        brand: "Pagani",
        price: 125,
        engine: "V12 6,0L",
        max: 370,
        version: "7 XTRAC",
        type: "Coupe",
        avatar: "https://i.ibb.co/Jy2CNJX/imola.webp",
        link: "/brands/pagani/huayra-imola",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "pagani_14",
        name: "Zonda Aether",
        brand: "Pagani",
        price: 159,
        engine: "V12 7,3L",
        max: 350,
        version: "6MT",
        type: "Coupe",
        avatar: "https://i.ibb.co/RQnhX1Y/aether.webp",
        link: "/brands/pagani/zonda-aether",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
];
export default Pagani;
